import { LOGOUT_USER } from '../../constants';
import { createAction } from 'redux-actions';
import setAuthorizationToken from '../../utils/setAuthorizationToken';
import { ROUTER_BASE_PATH } from '../../constants/siteConstants';
import Session from '../../utils/session';

export const logoutUser = createAction(LOGOUT_USER, () => {
  Session.remove();
  setAuthorizationToken(false);
  window.location.replace(`${ROUTER_BASE_PATH}/`);
  return {};
});
